require("prismjs/themes/prism-solarizedlight.css")
